import { Flex, Icon } from '@chakra-ui/react';
import { Grid01 } from '@kula-ai/icons/dual-tone/Grid01';
import { List } from '@kula-ai/icons/dual-tone/List';
import { useState } from 'react';

const defaultToggleList = [
  { label: 'Card view', id: 'card', icon: Grid01 },
  { label: 'Table view', id: 'table', icon: List },
];

export const TableCardToggle = ({
  currentView,
  toggleList = defaultToggleList,
  filterActions = () => {},
}) => {
  //todo: when going to different page and coming, we need to pick from reducer and keep here
  const [activeView, setActiveView] = useState(() =>
    currentView
      ? toggleList.find((i) => i.id === currentView)
      : toggleList?.length > 0
      ? toggleList[0]
      : {}
  );

  const handleViewChange = (item) => {
    setActiveView(item);
    filterActions({ type: 'view', view: item?.id });
  };

  return (
    <>
      {toggleList.map((item) => (
        <Flex
          w="1.75em"
          h="1.75em"
          key={item?.id}
          cursor="pointer"
          onClick={() => handleViewChange(item)}
          alignItems="center"
          justifyContent="center"
          borderRadius="6px"
          bgColor={activeView?.id === item?.id && 'ats-tertiary'}
        >
          <Icon as={item?.icon} color="secondary-900" />
        </Flex>
      ))}
    </>
  );
};
